import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
function Breadcrumb({ hotels }) {
  return (
    <div className="breadcrumbStyle">
      <div className="container">
        <Link to="/">Trang chủ</Link>
        <span className="breadcrumbSeparator">
          <FontAwesomeIcon icon="angle-right" />
        </span>
        <span>
          <Link to="/hotel">Khách sạn</Link>
        </span>
        <span className="breadcrumbSeparator">
          <FontAwesomeIcon icon="angle-right" />
        </span>
        <span className="active">
          <span>{hotels.name}</span>
        </span>
      </div>
    </div>
  );
}
export default Breadcrumb;
